import { findByCnpjInBigData } from "../repositories/integrations/bigdata";

const getCompanyDataByBigData = async (cnpj) => {
  const {
    data: responseBigData,
    data: {
      data: { data: clientData },
    },
  } = await findByCnpjInBigData(cnpj);

  if (!responseBigData.success)
    return {
      success: false,
      message: `Não foi possível buscar empresa a partir do documento ${cnpj}`,
    };

  return {
    success: true,
    reason: clientData?.corporate_name,
    fantasy: clientData?.commercial_name,
    corporate_name: clientData?.corporate_name,
    cnpj: clientData?.document,
    email: clientData?.emails?.[0]?.email,
    legal_nature: {
      code: clientData?.legal_nature.code,
      description: clientData?.legal_nature.description,
    },
    cnae: {
      code: clientData?.main_activity.code,
      text: clientData?.main_activity.text,
    },
    address: {
      street: clientData?.addresses?.[0]?.street,
      number: clientData?.addresses?.[0]?.number,
      postalCode: clientData?.addresses?.[0]?.postalCode,
      district: clientData?.addresses?.[0]?.bairro,
      city: clientData?.addresses?.[0]?.city,
      state: clientData?.addresses?.[0]?.stateCode,
      additionalInfo: clientData?.addresses?.[0]?.additionalInfo,
    },
    phones: clientData?.phones,
    situation: clientData?.situation,
    type: clientData?.type,
  };
};

export { getCompanyDataByBigData };
